module.exports = __webpack_public_path__ + "img/BreakfastAtWohnwagen.bf951dc8.jpg";